/*
* 多个文件上传组件
*/
<template>
  <div>
    <div>
      <a-upload
        :disabled="disabled"
        name="file"
        :multiple="true"
        :accept="accept"
        :headers="headers"
        :action="uploadUrl"
        :fileList="fileList"
        :remove="remove"
        :defaultFileList="fileList"
        :beforeUpload="beforeUpload"
        @preview="handlePreview"
        @change="event => handleChange(event, 'fileList')"
      >
        <div v-if="fileList.length < size">
          <a-button v-if="!disabled">
            <a-icon :style="iconSize" type="upload"/>上传
          </a-button>
        </div>
      </a-upload>
    </div>
  </div>
</template>

<script>

  import { UPLOAD_URL, parseFileRespon, FILE_DISPLAY_PREFIX, downloadFile } from '@/api/upload'
  import { genID } from '@/api/common'
  import {Button, Upload,Icon} from "ant-design-vue";
  import Message from "ant-design-vue/lib/message";
  export default {
    components: {
      'a-button': Button,
      'a-icon': Icon,
      'a-upload': Upload,
    },
    name: 'FileUpload',
    props: {
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false
      },
      // 文件接收类型
      accept: {
        type: String,
        default: undefined
      },
      iconSize: {
        type: Object,
        default: () => {
          return { width: '1em', height: '1em' }
        }
      },
      // true:上传功能 false:展示图片
      upload: {
        type: Boolean,
        default: true
      },
      // 回调函数,用来获取上传的图片地址路径,返回图片地址
      returnFun: {
        type: Function,
        default: undefined
      },
      size: {
        type: Number,
        default: 9
      },
      // 文件地址,以逗号分割
      fileUrls: {
        type: String,
        default: () => { return '' }
      },
      // 文件回显的数据
      fileItem: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        Message,
        headers: {
          authorization: 'authorization-text'
        },
        operation: true,
        viewer: null,
        genID,
        filePrefix: FILE_DISPLAY_PREFIX,
        uploadUrl: UPLOAD_URL + '/fileUploads',
        // 解析上传后的数据
        parseFileResponResult: parseFileRespon,
        previewImage: '',
        previewVisible: false,
        fileLoading: false,
        // 文件
        fileList: []
      }
    },
    mounted () {
      this.setFileItemList(this.fileItem)
    },
    computed: {
      picUrl () {
        return this.operation ? this.fileList.map(i => i.url) : this.fileList.map(i => i.url)
      }
    },
    watch: {
      fileUrls (val) {
        this.refreshUrl(val)
      },
      fileItem (val) {
        this.setFileItemList(val)
      },
      immediate: true,
      deep: true
    },
    methods: {
      // async handlePreview (file) {
      //   // console.log('file', file.url)
      //   this.previewImage = file.url
      //   this.previewVisible = true
      // },
      async handlePreview (file, index) {
        console.log('展示文件', file)
        downloadFile(file.url, file.name)
        // this.viewer.index = this.picUrl.findIndex(i => i === file.url)
        // this.viewer.show()
      },
      // 移除文件回调
      remove (file) {
        // console.log('移除', file)
        if (this.fileItem.length > 0) {
          this.fileItem.forEach((el, ind) => {
            if (el.uuid === file.uuid || el.uid === file.uid) {
              this.fileItem.splice(ind, 1)
              // console.log('删除')
            }
          })
        }
      },
      // 获取上传后的图片地址,使用,分割
      getUrlFun () {
        let picUrls = ''
        if (this.fileList.length > 0) {
          this.fileList.forEach(item => {
            if (picUrls === '') {
              picUrls = item.response ? this.parseFileResponResult(item.response) : item.url.replaceAll('/uploads', '')
            } else {
              const urlPath = item.response ? this.parseFileResponResult(item.response) : item.url.replaceAll('/uploads', '')
              picUrls += ',' + urlPath
            }
          })
        }
        return picUrls
      },
      // 获取上传图片
      getFileItem () {
        const picUrls = []
        if (this.fileList.length > 0) {
          this.fileList.forEach(item => {
            const file = {
              name: item.name,
              url: item.url.replaceAll('/uploads', '')
            }
            picUrls.push(file)
          })
        }
        return picUrls
      },
      // 刷新,用于详情图片回显使用
      refreshUrl (url) {
        // console.log(88888, url)
        if (!url || url.length < 1) {
          return
        }
        this.setImgUrlFile(url)
      },
      // 用于图片回显
      setImgUrlFile (url) {
        this.fileList = []
        if (url) {
          url.split(',').forEach(item => {
            item = FILE_DISPLAY_PREFIX + item
            // console.log(999, url)
            this.fileList.push(this.setFileItem('文件', item, item))
          })
          // console.log(this.picFile, 5868)
        } else {
          return []
        }
      },
      // 用于文件回显
      setFileItemList (item) {
        if (Array.isArray(item) && item.length > 0) {
          this.fileList = []
          const arr = []
          item.forEach(file => {
            if (file && typeof file === 'object') {
              file.uid = genID()
              file.url = FILE_DISPLAY_PREFIX + file.url
              file.thumbUrl = FILE_DISPLAY_PREFIX + file.thumbUrl
              file.status = 'done'
              arr.push(file)
            }
          })
          this.fileList = arr
        }
      },
      // 设置图片展示详情
      setFileItem (picName, url, simpleUrl) {
        // console.log(url)
        simpleUrl = simpleUrl || url
        const newItem = Object.assign({}, {
          name: picName,
          uid: genID(),
          status: 'done',
          url: url,
          thumbnail: simpleUrl,
          simpleUrl: simpleUrl,
          picName: picName
        })
        return newItem
      },
      // 文件上传前的校验
      beforeUpload (file) {
        // const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/gif'
        // if (!isJpgOrPng) {
        //   this.$message.error(this.$t('只能上传jpg、png或jpeg类型的文件!'))
        //   return isJpgOrPng
        // }
        // const isLt2M = file.size >> 20 < 10
        // if (!isLt2M) {
        //   this.$message.error(this.$t('图片必须小于 20MB!'))
        //   return isLt2M
        // }
        return true
      },
      handleChange (info, listStr) {
        if (info.file.status) {
          this[listStr] = info.fileList
        }
        if (info.file.status === 'uploading') {
          this.fileLoading = true
        } else if (info.file.status === 'error') {
          Message.error('图片上传失败!')
          this.fileLoading = false
        } else if (info.file.status === 'done') {
          if (info.file.response.code === 10000) {
            // 判断是否存在回调函数, 存在则将上传的图片地址返回
            if (this.returnFun) {
              const upFile = this.parseFileResponResult(info.file.response) || {}
              // console.log('文件', upFile)
              this.returnFun(upFile)
            }
            info.fileList.forEach(file => {
              if (file.response && info.file.response.code === 10000) {
                // Component will show file.url as link
                file.url = this.filePrefix + (this.parseFileResponResult(file.response) || {}).url
              }
              return file
            })
            this[listStr] = info.fileList
            // console.log('上传结果', info.file.response)
            // this[listStr][info.fileList.length - 1].url = this.filePrefix + (this.parseFileResponResult(info.file.response) || {}).url
          } else {
            Message.error(info.file.response.msg)
          }
          this.operation = !this.operation
        } else if (info.file.status === 'removed') {
        }
        this.$forceUpdate()
      }
    }
  }
</script>

<style scoped>

  /deep/.ant-upload.ant-upload-select {
    display: flex;
  }

</style>
